import { render, staticRenderFns } from "./assistant_history.vue?vue&type=template&id=75f0ebda&scoped=true&"
import script from "./assistant_history.vue?vue&type=script&lang=js&"
export * from "./assistant_history.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "75f0ebda",
  null
  
)

export default component.exports